/**
 *
 *  useEvent
 *  React hook
 *
 *  Created by Vladimir Shishlyannikov on 23/02/2023.
 *  Copyright (c) 2016-present iWoo Ltd. All rights reserved.
 *
 */

import { useLayoutEffect, useRef, useCallback } from "react";

export const useDangerousEvent = (t) => {
  return useEvent(t, true);
};

export const useEvent = (callback, s) => {
  const callbackRef = useRef(null);

  useRef(false);

  useLayoutEffect(() => {
    callbackRef.current = callback;
  });

  return useCallback((...rest) => {
    const callback = callbackRef.current;

    if (!callback) {
      throw new Error(
        "useEvent can not be called before the first render completes."
      );
    }

    return callback(...rest);
  }, []);
};
